
/*global google*/
import firebase from "firebase/app";
import 'firebase/firestore';
import Typography from '@material-ui/core/Typography';
import {Directionscontext} from '../componentes/directionscontext';
import React, { useContext } from "react";
import {
  InfoBox,
    withGoogleMap,
    GoogleMap,
    DirectionsRenderer
} from "react-google-maps";


export default function Map (props){


  const [state, setState]= React.useState( {
    directionsida:null,  directionsvolta:null, distancia: null, tempo: null, itinerarioida:[], tempototalvolta: null,
    itinerariovolta:[],
})
  

const directionsService = new google.maps.DirectionsService();
    const directionsServiceretorno = new google.maps.DirectionsService();
  const matrix = new google.maps.DistanceMatrixService();
  const geocoderdestino = new google.maps.Geocoder();
  const geocodersaida = new google.maps.Geocoder();
  const geocoderparadasida = new google.maps.Geocoder();
  const geocoderparadasvolta = new google.maps.Geocoder();
    var saida='';
    var dest='';
    var localdestino = props.destino;
    var localsaida = props.saida;
    var listapida= props.listaparadasida;
    var litsapvolta = props.listaparadasvolta;
    var listagoogleida=[];
    var listaida=[];
    var listaida2=[];
    var listavolta=[];
    var listavolta2=[];
    var delayFactor = 0;
    var delayFactor1 = 0;
    var delayFactor2 = 0;
    var delayFactor3 = 0;
    var delayFactor4 = 0;
    var totalvolta='';
    
   var {setageoida,setageovolta,setalistageoida, setalistageovolta} = useContext(Directionscontext);
  
  
 React.useEffect(() => {
  if((localdestino!=undefined)&&(localsaida!=undefined)){
    //geodestino();
    //geramapa();
    geramaparetorno();
  
   
 async function geramapa(){

  if((listapida!=undefined)&&(listapida[0].lat!='')){
      for (let index = 0; index < listapida.length; index++) {
        listagoogleida.push({location: new google.maps.LatLng(listapida[index])})
        
      }
    }
      console.log(listapida);
       console.log(listapida);
     
    await  directionsService.route(
        
         {
            
              //origin: saida,
              //destination: dest,

              origin: localsaida,
              destination: localdestino,


              travelMode: google.maps.TravelMode.DRIVING,
           waypoints: listagoogleida,
                
          },
          (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                
                setState({
                  directionsida: result
                  //console.log(`error fetching directions ` );
              }); 
               var total = 0;
                  var tempoida=0;
                  var myroute = result.routes[0];
                             

                  for (var i = 0; i < myroute.legs.length; i++) {
                    total += myroute.legs[i].distance.value;
                    tempoida += myroute.legs[i].duration.value;
                  }
                  //total = total / 1000;
                  tempoida = tempoida/60
                  
                
                  var totalf = total + totalvolta;
                  totalf = totalf/1000
                  var t = totalf.toFixed(0);
                  
                     
                  props.setakm(t);                     
                
              } else if (status === google.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
                delayFactor3++;
                setTimeout(function () {
                  geramapa()
                }, delayFactor3 * 1100);
            } else {
                console.log("Error: " + status);
            }
              
          }
          
      )
      
        
      
        }
      
      
  


  async function geramaparetorno(){
    if((litsapvolta!=undefined)&&(litsapvolta[0].lat!='')){
      for (let index = 0; index < litsapvolta.length; index++) {
        listavolta.push({location: new google.maps.LatLng(litsapvolta[index])})
        
      }
    }
    
    await directionsServiceretorno.route(
      
       {
            
        origin: localdestino,
        destination: localsaida,
        travelMode: google.maps.TravelMode.DRIVING,
     waypoints: listavolta,
           
    },
    (results, status) => {
        if (status === google.maps.DirectionsStatus.OK) {

          setState({
            directionsvolta: results
              
          });
          var tempovolta=0;
          var total = 0;
          var myroute = results.routes[0];
         // var leg = results.routes[0].legs;

          /*setState({
            itinerariovolta: leg
            //console.log(`error fetching directions ` );
        });*/

          for (var i = 0; i < myroute.legs.length; i++) {
            total += myroute.legs[i].distance.value;
            tempovolta += myroute.legs[i].duration.value;
          }
          //total = total / 1000;
          tempovolta = tempovolta
          props.setatemporetorno(tempovolta);
          //alert(`error fetching directions `, tempovolta);
         /* setState({
            tempototalvolta: tempovolta
            
        });*/
        totalvolta=total;
         
         

                       
           geramapa();
           
        } else if (status === google.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
          delayFactor4++;
          setTimeout(function () {
            geramaparetorno()
          }, delayFactor4 * 1100);
      } else {
          console.log("Error: " + status);
      }
        
    }
)
     
  }

 




}



  
},[localsaida]);



/** <InfoBox
      defaultPosition={new google.maps.LatLng(saida)}
      options={{ closeBoxURL: ``, enableEventPropagation: true }}
    >
      <div style={{ backgroundColor: `yellow`, opacity: 0.75, padding: `12px` }}>
        <div style={{ fontSize: `16px`, fontColor: `#08233B` }}>
          Hello, Taipei!
        </div>
      </div>
    </InfoBox> */

const GoogleMapExample = withGoogleMap(props => (
        <GoogleMap
            defaultCenter={{ lat: -29.7215493, lng:  -53.71837069999999 }}
            defaultZoom={1}
            
            
        >
        
            
             <DirectionsRenderer
                directions={state.directionsida}

            />
            
            
                      

        </GoogleMap>

        
    )
    
    
    );

   /* var logs =  state.itinerarioida.map(item=>(
      <Typography variant="body2" color="textSecondary" component="p">
     De: {item.start_address }
     <br></br>
     Para:{item.end_address}
     <br></br>
     Tempo previsto de deslocamento: {item.duration.text}
      
      
    </Typography>

   ));
   var logsvolta =  state.itinerariovolta.map(item=>(
    <Typography variant="body2" color="textSecondary" component="p">
   De: {item.start_address }
   <br></br>
   Para:{item.end_address}
   <br></br>
   Tempo previsto de deslocamento: {item.duration.text}
    
    
  </Typography>

 ));*/
    
    return (
      
      
     /*
        <div>
          
                     
            <Typography variant="body2" color="textSecondary" component="p">
              
               Tempo previsto para chegada ao destino: {state.tempo} minutos.
               
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
              <br></br>
              <br></br>
              Itinerário Completo de ida: 
              
              {logs}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
            <br></br>
              <br></br>
              Itinerário Completo de retorno: 
              
              {logsvolta}
              <br></br>
            </Typography>

         */
        <div>

            
           
             <GoogleMapExample
            containerElement={<div style={{ height: `400px`, width: "365px" }} />}
            mapElement={<div style={{ height: `100%` }} />}
            painel={<div style={{ height: `30%` }}/>}
        />






        </div>
        


    )
    }


